import { useState,useEffect,useContext} from 'react';
import { useNavigate,useLocation} from 'react-router-dom';
import {Country,State} from 'country-state-city';
import { PassContext } from '../../../../hooks/PassContext.js';
import axios from 'axios';
import './Delivery.css';
import { Stepper } from './Stepper.js';
import { CART_BASE_URL } from '../../../../config/ApiConfig.js';
import { showNotification } from '../../../../services/NotificationService.js';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const Delivery = ()=>{
    const  { types,error } = useContext(PassContext);
    const [cartItems, setCartItems] = useState([]);
    const [state,setState]=useState('');
    const [country,setCountry]=useState('US');
    //For Address Validation
    const [addressValidationError, setAddressValidationError] = useState('');
    const [isAddressValidated, setIsAddressValidated] = useState(true);
    //For Zip Validation
    const [isZipValidated, setIsZipValidated] = useState(true);
    const [zipValidationError, setZipValidationError] = useState('');
    //For Shipping
    const [shippingDetails, setShippingDetails] = useState({
        mailingFirstName: '',
        mailingLastName: '',
        mailingAddress: '',
        mailingAddress2: '',
        mailingCity: '',
        mailingState: '',
        mailingZip: '',
        mailingCountry: 'US',
        email: '',
    });
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [formError,setFormError]=useState('');
    const navigate = useNavigate();
    const location=useLocation();
    const { cartId ,cartGUID,passes,passItem} = location.state || {}; //cartId,cartGUID Passes recieved from Cart Component first time ,we don't have passItem here || and  cartId and passItem, recieved from Review Component when i link to Delivey Component for Edit some shipping Data And Billing Data or Payment Data from Review Component

    useEffect(() => {
        if (error) {  // Show error only if the API call has failed
            setErrorMessage('We encountered an issue  Please refresh the page or try again later');
        } else {
            setErrorMessage('');
        }
    }, [error]);

    useEffect(() => { 
        setErrorMessage('');
        if (!types || types.length === 0) {
            return; // Wait until types is populated
        }
        
        const fetchOrderDetails = async () => {
            try {
                const response = await axios.get(`${CART_BASE_URL}/GetCartDetailsByGUID/${cartGUID}`);               
                const { shippingDetails: apiShippingDetails} = response.data.data.cartDetails || {};
                const { emailId } = response.data.data.cartDetails || '';
                const savedResponseForCart = response.data.data.cartDetails.passes;
                // Filter types to only include passes that exist in savedResponseForCart
                const filteredTypes = types.filter(type => {
                    return(
                        savedResponseForCart.some(order => order.passID === type.passID)
                    )
                } 
                );
                const mergedOrdersData = filteredTypes.map(type => {
                    // Find the first matching order for this passID in savedResponseForCart
                    const matchingOrder = savedResponseForCart.find(order => order.passID === type.passID);
                    // Combine type data with the matching order information
                    return {
                        ...type,
                        quantity: matchingOrder ? matchingOrder.quantity : 0,
                        passDate: matchingOrder ? matchingOrder.passDate : null,
                    };
                });
                setCartItems(mergedOrdersData);

                // Map API response to component state
                if (apiShippingDetails) {
                    // If apiShippingDetails is not null or undefined, update the state
                    setShippingDetails({
                        mailingFirstName: apiShippingDetails.shippingFirstName || '',
                        mailingLastName: apiShippingDetails.shippingLastName || '',
                        mailingAddress: apiShippingDetails.shippingAddress1 || '',
                        mailingAddress2: apiShippingDetails.shippingAddress2 || '',
                        mailingCity: apiShippingDetails.shippingCity || '',
                        mailingState: apiShippingDetails.shippingState || '',
                        mailingZip: apiShippingDetails.shippingZip || '',
                        mailingCountry: apiShippingDetails.shippingCountry || 'US',
                        email: response.data.data.cartDetails.emailId,
                    });
                    // Set the state and country based on the response
                    setState(apiShippingDetails.shippingState || '');
                    setCountry(apiShippingDetails.shippingCountry || 'US');
                }else{
                    if(emailId){
                        setShippingDetails({
                            email:emailId
                        })
                    }
                }
            } catch (error) {
                console.error('Error fetching order details:', error);
                showNotification("Oops! Something went wrong. Please try again later.","error");
                setErrorMessage(`Sorry, we're unable to load delivery page at the moment. Please try refreshing the page or come back later.`);
            }
        };
        fetchOrderDetails();
    }, [cartGUID,types]);

    const handleStateChange = (e) => {
        const selectedState = e.target.value;
        // Manually create the updated details object
        const updatedDetails = {
            ...shippingDetails,
            mailingState: selectedState, // Update mailingState directly
        };
        setShippingDetails(updatedDetails);
        setState(selectedState);
        // Remove error if the state field is filled
        if (errors.mailingState) {
            setErrors({ ...errors, mailingState: selectedState ? '' : errors.mailingState });
        }
        // Perform USPS validation check with the updated details
        if (updatedDetails.mailingAddress && updatedDetails.mailingCity && updatedDetails.mailingState) {
            checkForUSPSValidation(updatedDetails);  // Pass the updated details
        }
    };

    const handleCountryChange = (e) => {
        const selectedCountry = e.target.value;
        setCountry(selectedCountry);
        if(selectedCountry==='CA'){
            setIsZipValidated(true);
            setIsAddressValidated(true);
        }
        setShippingDetails(prev => ({
            ...prev,
            mailingZip: '',
            mailingState:''
        }));
        // Clear ZIP code error if it exists
        setErrors(prev => {
            const { mailingZip, ...rest } = prev;
            return rest;
        });
    };

    const handleShippingChange = (e) => {
        const { name, value } = e.target;
        const updatedDetails = { ...shippingDetails, [name]: value };
        setShippingDetails(updatedDetails);
        // Remove error for the specific field when user starts typing
        if (errors[name]) {
            setErrors({ ...errors, [name]: value.trim() ? '' : errors[name] });
        }
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;        
        if (name === 'mailingZip' && value.length === 5) {
            validateAddressWithUSPSByZip(value);
        }
        if (['mailingAddress', 'mailingCity', 'mailingState'].includes(name)) {
            checkForUSPSValidation(shippingDetails);
        }
    };

    const checkForUSPSValidation = (updatedDetails) => {
        const { mailingAddress, mailingCity, mailingState } = updatedDetails;
        if (mailingAddress && mailingCity && mailingState && country === 'US') {
            validateAddressWithUSPS(updatedDetails);
        }
    };   
      //These states are for loader while hitting USPS api
      const [isCityStateLoading, setIsCityStateLoading] = useState(false);
      const [isZipLoading, setIsZipLoading] = useState(false);
      const [isStateLoading,setIsStateLoading]= useState(false);
      //Validation Based on Address Standarized
      const validateAddressWithUSPS = async (details) => {
        setIsZipLoading(true);
          const { mailingAddress, mailingCity, mailingState } = details;
          // Check if the state has more than two characters
          if (mailingState.length > 2) {
            setAddressValidationError('Selected state is not available for shipping.');
            setIsAddressValidated(false);
            setIsZipLoading(false)
            return;
          }  
            try {
                const response = await axios.post(`${CART_BASE_URL}/usps/ValidateAddress`,{
                    "streetAddress":mailingAddress,
                    "city":mailingCity,
                    "state":mailingState,
                },{
                    headers:{
                        "Content-Type":"application/json"
                    }
                });
  
              // Check the response data for validation
                if (response.data && response.data.data) {
                    setShippingDetails((prevDetails) => ({
                        ...prevDetails,
                        mailingZip: response.data.data.ZIPCode, // Update mailingState directly
                    }));
                    setIsAddressValidated(true);
                    setIsZipValidated(true);
                    // Clear ZIP error if ZIP is now valid
                    if (errors.mailingZip) {
                        setErrors((prevErrors) => ({ ...prevErrors, mailingZip: '' }));
                    }
                } else {
                    setAddressValidationError('Address validation failed. Please check your address.');
                    setIsAddressValidated(false);

              }
            }catch (error) {
                setShippingDetails((prevDetails) => ({
                    ...prevDetails,
                    mailingZip: '', // Update mailingState directly
                }));
                setAddressValidationError(error.response.data.message);
                setIsAddressValidated(false);
            }finally {
                setIsZipLoading(false); // Hide loader in ZIP field
                setIsZipValidated(true);//Hide Zip Error Message in case if it display
            }
        };

        // Validation by ZIP code to auto-fill City and State
        const validateAddressWithUSPSByZip = async (zipCode) => {
            if (country !== 'US') {
                return;
            }
            setIsCityStateLoading(true); 
            setIsStateLoading(true)
            try {
                const response = await axios.post(`${CART_BASE_URL}/usps/ValidateZipCode`,{
                    "zipCode":zipCode,
                },{
                    headers:{
                        "Content-Type":"application/json"
                    }
                });
                if (response.data && response.data.data.city && response.data.data.state) {
                    setShippingDetails((prevDetails) => ({
                        ...prevDetails,
                        mailingCity: response.data.data.city,
                        mailingState: response.data.data.state,
                    }));
                    setState(response.data.data.state);
                    setIsZipValidated(true);  // Mark ZIP validation as complete
                    setIsAddressValidated(true);
                    // Clear City error And State Error if ZIP code is ok
                    if (errors.mailingState || errors.mailingCity) {
                        setErrors((prevErrors) => ({ ...prevErrors, mailingCity: '',mailingState:'' }));
                    }
                } else {
                    setZipValidationError('ZIP code validation failed.');
                    setIsZipValidated(false);
                }
            }catch (error) {
                setShippingDetails((prevDetails) => ({
                    ...prevDetails,
                    mailingCity: '',
                    mailingState: '',
                }));
                setZipValidationError(error.response.data.message);
                setIsZipValidated(false);
            }finally {
                setIsCityStateLoading(false); // Hide loader in city and state fields
                setIsStateLoading(false);
                setIsAddressValidated(true);
            }
        };
    let hasPassIdOne;
    if(passItem){
        hasPassIdOne = passItem.some(item => item.passID === 1);
    }else{
        hasPassIdOne = passes.some(item => item.passID === 1);
    }
    let hasAnnualPass=hasPassIdOne
    // Validation rules
    const validate = () => {
        const newErrors = {};
        const { mailingFirstName, mailingLastName, mailingAddress, mailingCity,mailingState, mailingZip, email } = shippingDetails; 
        let isValid = true;
        // Check if the cart contains only the one-day pass
        if (!hasPassIdOne) {
            // Only email is required for one-day pass
            if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
                newErrors.email = 'Please enter a valid email address.';
                isValid = false;
            }
        } else {
             // Full validation for other shipping details
             if (!mailingFirstName ||!mailingFirstName.trim()) { // Updated regex
                newErrors.mailingFirstName = 'First name is must.';
                isValid = false;
            }
            if (!mailingLastName || !mailingLastName.trim()) { // Updated regex
                newErrors.mailingLastName = 'Last name is must.';
                isValid = false;
            }
            if (!/^[a-zA-Z0-9\s,.-]{1,}$/.test(mailingAddress)) {
                newErrors.mailingAddress = 'Address must contain at least 1 characters.';
                isValid = false;
            }
            if (!/^(?!\s)[A-Za-z\s]{1,}$/.test(mailingCity)) {
                newErrors.mailingCity = 'City must contain at least 1 or more non-whitespace characters.';
                isValid = false;
            }
            if (!mailingState.trim()) {
                newErrors.mailingState = 'State is required.';
                isValid = false;
            }
            const countryInfo = Country.getCountryByCode(country);
            const zipRegex = countryInfo.isoCode !== 'CA'? /^\d{5}(-\d{4})?$/: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
            if (!zipRegex.test(mailingZip)) {
                if (countryInfo.isoCode === 'CA') {
                    newErrors.mailingZip = `ZIP code must match the format: A1A 1A1 for ${countryInfo.name}.`;
                } else {
                    newErrors.mailingZip = `ZIP code must follow the format: 12345 for ${countryInfo.name}.`;
                }
                isValid = false;
            }
            if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
                newErrors.email = 'Please enter a valid email address.';
                isValid = false;
            }
        }
        if (!isValid) {
            setFormError('Please check the forms and ensure all the required fields are completed.');
            setTimeout(() => {
                const formStart = document.getElementById('formStartsAt');
                if (formStart) {
                    formStart.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100); // Smooth scroll to form section
        } else {
            setFormError('');
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    
    const formSubmitHandler = async (event) => { 
        event.preventDefault();
        if (validate()) {
            const shippingData={
                cartID:cartId,
                "shippingFirstName": shippingDetails.mailingFirstName || '',
                "shippingLastName": shippingDetails.mailingLastName || '',
                "shippingAddress1": shippingDetails.mailingAddress || '',
                "shippingAddress2": shippingDetails.mailingAddress2? shippingDetails.mailingAddress2: '',
                "shippingCity": shippingDetails.mailingCity || '',
                "shippingState": state || '',
                "shippingZip": shippingDetails.mailingZip || '',
                "shippingCountry": country || '',
                "emailID": shippingDetails.email || '',
              }
            try {
                const response = await axios.post(`${CART_BASE_URL}/SaveUpdateShippingDetails`, shippingData, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                if(isAddressValidated === true && isZipValidated === true && response.status===200 && !isZipLoading && !isCityStateLoading){
                    if(hasPassIdOne){
                    }
                    navigate('/billing',{ state: { cartId,cartGUID,hasAnnualPass } }); 
                }
            } catch (error) {
                console.error('Error during Axios request:', error);
                showNotification("Unable to save or update the shipping details at the moment. Please try again later.", "error");
            }
        }
    };
    //Filter for Countries
    const allowedCountries = Country.getAllCountries().filter(
        (country) => country.isoCode === 'US' || country.isoCode === 'CA'
    );
    return(
        <>
            <div className='container-delivery my-5'>
                <div className='main-delivery'>
                {errorMessage ? (
                    <h3 className='errorHandled'>{errorMessage}</h3>
                ) : cartItems.length === 0 ? (
                    <div className="skeleton-wrapper d-flex flex-column">
                        <Skeleton height={30} width="100px" />
                        <Skeleton height={15} width="60%" />
                        <Skeleton height={15} width="50%" />
                        <Skeleton height={100} width="100%" />
                        <Skeleton height={30} width="40%" />
                        <Skeleton count={5} width="80%" />
                    </div>
                ) :<>
                    <Stepper currentStep={1}></Stepper>
                    {
                        formError && 
                        <>  
                            <div className="errBox" style={{display: "block;"}}>{formError}</div>
                        </>
                    }
                    <form method='POST' name="dpForm" onSubmit={formSubmitHandler}>
                        <>  
                            <div className="checkout-cols d-flex justify-content-center">
                                <div className="checkout-col checkout-data">
                                    <h2>Delivery Method</h2>
                                    {
                                        cartItems && cartItems.map((item) => {
                                            const getExpirationDate = () => {
                                                let today = new Date(); // Get current date in local timezone
                                                let count = 0;
                                                // Convert to UTC to avoid timezone shifts
                                                today = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
                                                // Increment the date by 1 day while excluding weekends
                                                while (count < 15) {
                                                    today.setUTCDate(today.getUTCDate() + 1);
                                            
                                                    // Check if the new date is a weekend
                                                    if (today.getUTCDay() !== 6 && today.getUTCDay() !== 0) {
                                                        count++;
                                                    }
                                                }
                                                // Format the date in UTC to ensure consistency
                                                const options = { year: 'numeric', month: 'long', day: '2-digit', timeZone: 'UTC' };
                                                let formattedDate = today.toLocaleDateString('en-US', options);
                                            
                                                formattedDate = formattedDate.replace(/(\w+)(\s)/, "$1 ");
                                                return formattedDate;
                                            };
                                            
                                            return (
                                                <div key={item.passID}>
                                                    <h3>{item.longName}</h3>
                                                    <p className='onedaypass'>
                                                        {item.passID === 1 ? <>Your annual Discover Pass will be sent to you via USPS First Class Mail on or before <strong>{getExpirationDate()}.</strong><br/><br/>
                                                    A temporary pass will be emailed to you and expires on <strong>{getExpirationDate()}. </strong>After finalizing your purchase, you can download and print your temporary pass for immediate use. If you are unable to print, write the transaction number and date from your email receipt on a piece of paper in large bold print and display it on your car's dashboard until you receive the pass in the mail.</> :
                                                            `Your one-day Discover Pass will be sent to you via email and will be printable at the end of the checkout process. You can download and print your pass for immediate use. If you are unable to print, write the transaction number and date on a piece of paper in large bold print and display it on your car's dashboard.`}
                                                    </p>
                                                </div>
                                            )
                                        })
                                    }
                                    <label htmlFor="email" className={errors.email ? 'error-label' : ''}>What is your email address?</label>
                                    <input type="email"
                                        className={`textEntry ${errors.email ? 'error-input' : ''}`}
                                        name="email"
                                        value={shippingDetails.email}
                                        onChange={handleShippingChange}
                                        />
                                </div>
                                {
                                    hasPassIdOne && <>
                                        <div className="checkout-divider"></div>
                                        <div className="checkout-col checkout-data">
                                            <h2>Shipping Address</h2>
                                            {/* First Name */}
                                            <label htmlFor="mailingFirstName" className={errors.mailingFirstName ? 'error-label' : ''}>First Name</label>
                                            <input
                                                type="text"
                                                className={`textEntry ${errors.mailingFirstName ? 'error-input' : ''}`}
                                                name="mailingFirstName"
                                                value={shippingDetails.mailingFirstName}
                                                onChange={handleShippingChange}
                                                maxLength={40}
                                            />
                                            {/* Last Name */}
                                            <label htmlFor="mailingLastName" className={errors.mailingLastName ? 'error-label' : ''}>Last Name</label>
                                            <input
                                                type="text"
                                                className={`textEntry ${errors.mailingLastName ? 'error-input' : ''}`}
                                                name="mailingLastName"
                                                value={shippingDetails.mailingLastName}
                                                onChange={handleShippingChange}
                                                maxLength={40}
                                            />

                                            {/* Mailing Address */}
                                            <label htmlFor="mailingAddress" className={errors.mailingAddress ? 'error-label' : ''}>Primary Mailing Address </label>
                                            <input
                                                type="text"
                                                className={`textEntry ${errors.mailingAddress ? 'error-input' : ''}`}
                                                name="mailingAddress"
                                                value={shippingDetails.mailingAddress}
                                                onChange={handleShippingChange}
                                                onBlur={handleBlur}
                                                maxLength={50}
                                            />

                                            {/* More Address */}
                                            <label htmlFor="mailingAddress2">Secondary Address</label>
                                            <input
                                                type="text"
                                                className="textEntry"
                                                name="mailingAddress2"
                                                value={shippingDetails.mailingAddress2}
                                                onChange={handleShippingChange}
                                                maxLength={50}
                                            />

                                            {/* City */}
                                            <label htmlFor="mailingCity" className={errors.mailingCity ? 'error-label' : ''}>City</label>
                                            <input
                                                type="text"
                                                className={`textEntry ${errors.mailingCity ? 'error-input' : ''} ${isCityStateLoading ? 'input-loading' : ''}`}
                                                name="mailingCity"
                                                value={shippingDetails.mailingCity}
                                                onChange={handleShippingChange}
                                                onBlur={handleBlur}
                                                disabled={isCityStateLoading}
                                                maxLength={50}
                                            />
                                            {/* State */}
                                            <label htmlFor="mailingState"  className={errors.mailingState ? 'error-label' : ''}>State/Province/Region</label>
                                            <select
                                                className={`textEntry text-select ${errors.mailingState ? 'error-input' : ''} ${isStateLoading ? 'input-loading' : ''}`}
                                                name="mailingState"
                                                value={shippingDetails.mailingState}
                                                onChange={handleStateChange}
                                                disabled={isStateLoading}
                                            >
                                                <option value="" >
                                                    Select a State
                                                </option>
                                                {State.getStatesOfCountry(country).map((stateItem) => (
                                                    <option key={stateItem.isoCode} value={stateItem.isoCode}>
                                                        {stateItem.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {/* ZIP Code */}
                                            <label htmlFor="mailingZip">ZIP/Postal Code</label>
                                            <input
                                                type="text"
                                                className={`textEntry ${errors.mailingZip ? 'error-input' : ''} ${isZipLoading ? 'input-loading' : ''}`}
                                                name="mailingZip"
                                                value={shippingDetails.mailingZip}
                                                onChange={handleShippingChange}
                                                onBlur={handleBlur}
                                                maxLength={country === 'CA' ? 7 : 5}
                                                disabled={isZipLoading} 
                                                onKeyPress={(e) => {
                                                    const isCA = country === 'CA';
                                                    const key = e.key;
                                                    if (isCA) {
                                                        if (!/[A-Za-z0-9 ]/.test(key)) {
                                                            e.preventDefault();
                                                        }
                                                    } else {
                                                        if (!/[\d-]/.test(key)) {
                                                            e.preventDefault();
                                                        }
                                                    }
                                                }}
                                                onInput={(e) => {
                                                    let value = e.target.value;
                                                    if (country !== 'CA') {  
                                                        value = value.replace(/\D/g, '');// Remove all non-digit
                                                        if (value.length > 5) {
                                                            value = `${value.slice(0, 5)}-${value.slice(5, 9)}`;
                                                        }
                                                        e.target.value = value;
                                                    }
                                                }}
                                            />
                                            {errors.mailingZip && <span className="error-text">{errors.mailingZip}</span>}

                                            {/* Country */}
                                            <label htmlFor="mailingCountry">Country</label>
                                            <select
                                                className="textEntry text-select"
                                                name="mailingCountry"
                                                value={country}
                                                onChange={handleCountryChange}
                                            >
                                                {allowedCountries.map((countryItem) => (
                                                    <option key={countryItem.isoCode} value={countryItem.isoCode}>
                                                        {countryItem.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {
                                                isAddressValidated===false && 
                                                    <> 
                                                    <p style={{color:"rgb(153, 0, 0)",fontWeight:"bold",marginTop:"8px"}}>{addressValidationError}</p>
                                                    </>
                                            }
                                            {
                                                isZipValidated===false && <>
                                                <p style={{color:"rgb(153, 0, 0)",fontWeight:"bold",marginTop:"8px"}}>{zipValidationError}</p>
                                                </>
                                            }
                                        </div>
                                    </>
                                }
                            </div>
                            <input type="submit" value="Continue" className=" submission add-button add-button-continue" />
                        </>
                        </form>
                    </>}
                </div>
            </div>
        </>
    )
}